<template>
    <div class="cancle-modal" @click.stop.prevent="handleClose(false)" @mousedown="handleClose(false)">
        <div class="main-c" @click.stop.prevent @mousedown.stop>
            <div class="title">是否要取消投票</div>
            <div class="btn-c">
                <div class="btn-1" @click="handleClose(false)">否</div>
                <div class="btn-2" :style="getBtnStyle()" @click="handleClose(true)">是</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['page'],
    data() {
        return {
            
        }
    },
    methods: {
        handleClose(flag) {
            this.$emit('closeCancleModal',flag)
        },
        getBtnStyle() {
            return {
                '--background-color': this.isFocus?'#DD2222':'#FFD100',
                '--font-color': this.isFocus?'#fff':'#111',
            }
        }
    },
    computed: {
        isFocus() {
            return this.page == 'focus'
        }
    }
}
</script>
<style lang="less" scoped>
    .cancle-modal {
        position: fixed;
        z-index: 1001;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        .main-c {
            cursor: pointer;
            position: absolute;
            bottom: 0;
            left: 0;
            top: 0;
            right: 0;
            margin: auto;
            width: 444px;
            height: 150px; 
            background: #FFFFFF;
            border-radius: 4px; 
            padding: 32px 32px 24px 32px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            color: #111;
            box-sizing: border-box;
            .title {
                height: 22px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #111111;
                line-height: 22px;
                text-align: left;
                font-style: normal;
            }
            .btn-c {
                display: flex;
                .btn-1 {
                    width: 104px;
                    height: 36px;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #F2F2F2;
                    margin: 0 8px 0 164px;
                }
                .btn-2 {
                    width: 104px;
                    height: 36px;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: var(--background-color);
                    color: var(--font-color);
                }
            }
        }
    }
</style>